import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";
import MoleculeBg from "@/components/brand/MoleculeBg";

export default function NotFound() {
  useSEO({
    title: "Page Not Found | Renova Peptide Co.",
    description: "The page you are looking for could not be found.",
    noindex: true,
  });
  return (
    <section className="relative bg-[#111C32] min-h-[70vh] flex items-center overflow-hidden" data-testid="not-found">
      <MoleculeBg className="absolute right-0 top-0 w-1/2 h-full" color="#C8A96A" opacity={0.14} />
      <div className="container-rnv relative z-10 text-center">
        <p className="overline !text-[#D8BE87]">Error 404</p>
        <h1 className="font-serif font-light text-[#F7F4EF] text-6xl md:text-8xl mt-4">Page Not Found</h1>
        <p className="mt-6 text-[#B9BCC4] max-w-md mx-auto">
          The page you are looking for may have moved or no longer exists.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="btn-navy !bg-[#C8A96A] !text-[#111C32] hover:!bg-[#D8BE87]">Return Home</Link>
          <Link to="/shop" className="btn-gold !text-[#F7F4EF] !border-[#C8A96A]">Browse Shop</Link>
        </div>
      </div>
    </section>
  );
}
